import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Panda Demo - Dumpster Rentals &amp; Demolition in Broward &amp; Palm Beach</title>
        <meta property="og:title" content="Panda Demo - Dumpster Rentals & Demolition in Broward & Palm Beach" />
        <link
          rel="canonical"
          href="https://www.pandademolition.com/"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-section">
        <div className="hero-media-container">
          <video
            src="https://videos.pexels.com/video-files/4760922/4760922-hd_1920_1080_24fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/4760922/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-video"
          ></video>
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content-wrapper">
          <div className="hero-center">
            <img
              src="/images/logo.png"
              alt="Panda Demolition & Disposal"
              className="hero-logo-main"
            />
            <h1 className="home-hero-title hero-title">
              Dumpster Rentals &amp; Demolition<br/>in Broward &amp; Palm Beach
            </h1>
            <div className="hero-badge-row">
              <span className="hero-badge">Same Day Delivery</span>
              <span className="hero-badge">Flat-Rate Pricing</span>
              <span className="hero-badge">Broward &amp; Palm Beach</span>
            </div>
            <div className="hero-cta-group">
              <a href="tel:+19544081674" className="hero-cta-primary">
                <svg fill="none" width="24" height="24" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <span>Call Now — (954) 408-1674</span>
              </a>
              <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="hero-cta-secondary">
                <svg fill="none" width="24" height="24" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
                <span>Book a Dumpster</span>
              </button>
            </div>
            <div className="hero-trust-row">
              <div className="hero-trust-item">
                <svg fill="none" width="18" height="18" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"></path></svg>
                <span>15+ Years Experience</span>
              </div>
              <div className="hero-trust-item">
                <svg fill="none" width="18" height="18" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"></path></svg>
                <span>12,000+ Dumpsters Delivered</span>
              </div>
              <div className="hero-trust-item">
                <svg fill="none" width="18" height="18" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"></path></svg>
                <span>98% On-Time Rate</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Quote Popup Modal */}
      <dialog id="quote-modal" className="quote-modal">
        <div className="quote-modal-content">
          <button id="close-quote-modal" className="quote-modal-close">&times;</button>
          <h2 className="quote-modal-title">Get Your Free Quote</h2>
          <p className="quote-modal-sub">We respond in under 30 minutes</p>
          <form id="lead-form" className="quote-modal-form">
            <input type="text" name="name" required placeholder="Your Name" className="quote-modal-input" />
            <input type="tel" name="phone" required placeholder="Phone Number" className="quote-modal-input" />
            <input type="email" name="email" placeholder="Email (optional)" className="quote-modal-input" />
            <select name="service" className="quote-modal-input">
              <option value="dumpster">Dumpster Rental</option>
              <option value="demolition">Demolition</option>
              <option value="debris">Debris Hauling</option>
              <option value="other">Other</option>
            </select>
            <textarea name="message" rows="3" placeholder="Tell us about your project (optional)" className="quote-modal-input quote-modal-textarea"></textarea>
            <button type="submit" className="quote-modal-submit">Get My Free Quote</button>
            <p id="lead-form-status" style={{textAlign: 'center', marginTop: '8px', display: 'none'}}></p>
          </form>
          <p className="quote-modal-privacy">No spam. No obligations. Just a quote.</p>
        </div>
      </dialog>
      <section id="order" className="features-section">
        <div className="section-header">
          <h2 className="section-title">Rent a Dumpster</h2>
          <p className="section-content">
            Choose the right size for your project. Flat-rate pricing with no
            hidden fees.
          </p>
        </div>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon-box">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </div>
            <h3 className="feature-name">10 Yard Bin</h3>
            <p className="feature-price">Starting at $299</p>
            <p className="section-content">
              Ideal for garage cleanouts or small bathroom remodels.
            </p>
            <button className="btn-primary btn btn-sm" onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')}>Order 10yd</button>
          </div>
          <div className="feature-card">
            <div className="feature-icon-box">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </div>
            <h3 className="feature-name">20 Yard Bin</h3>
            <p className="feature-price">Starting at $399</p>
            <p className="section-content">
              Perfect for basement finishing or deck removals.
            </p>
            <button className="btn-primary btn btn-sm" onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')}>Order 20yd</button>
          </div>
          <div className="feature-card">
            <div className="feature-icon-box">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </div>
            <h3 className="feature-name">30 Yard Bin</h3>
            <p className="feature-price">Starting at $499</p>
            <p className="section-content">
              Best for major home renovations or estate cleanups.
            </p>
            <button className="btn-primary btn btn-sm" onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')}>Order 30yd</button>
          </div>
          <div className="feature-card">
            <div className="feature-icon-box">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                <circle r="2" cx="17" cy="18"></circle>
                <circle r="2" cx="7" cy="18"></circle>
              </svg>
            </div>
            <h3 className="feature-name">Same-Day Delivery</h3>
            <p className="feature-price">Available Daily</p>
            <p className="section-content">
              Book before 10 AM for guaranteed same-day drop-off.
            </p>
            <a href="/contact"><button className="btn-outline btn btn-sm">Check Areas</button></a>
          </div>
          <div className="feature-card">
            <div className="feature-icon-box">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" rx="2" ry="2" width="18" height="18"></rect>
                <line x1="16" x2="16" y1="2" y2="6"></line>
                <line x1="8" x2="8" y1="2" y2="6"></line>
                <line x1="3" x2="21" y1="10" y2="10"></line>
              </svg>
            </div>
            <h3 className="feature-name">Flexible Rental</h3>
            <p className="feature-price">7-14 Day Periods</p>
            <p className="section-content">
              Keep the bin as long as you need. Extensions available.
            </p>
            <a href="/dumpster-rental"><button className="btn-outline btn btn-sm">View Terms</button></a>
          </div>
          <div className="feature-card">
            <div className="feature-icon-box">
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                <polyline points="9 22 9 12 15 12 15 22"></polyline>
              </svg>
            </div>
            <h3 className="feature-name">Residential Safe</h3>
            <p className="feature-price">Driveway Protection</p>
            <p className="section-content">
              We use protective boards to ensure your property is safe.
            </p>
            <a href="/services"><button className="btn-outline btn btn-sm">Learn More</button></a>
          </div>
        </div>
      </section>
      <section id="rfq" className="rfq-cta-section">
        <div className="rfq-container">
          <div className="rfq-info">
            <h2 className="section-title">Large Project? Get an RFQ</h2>
            <p className="section-content">
              For commercial demolition or complex debris hauling, submit a
              Request for Quote and our team will provide a detailed estimate
              within 24 hours.
            </p>
          </div>
          <div className="rfq-steps">
            <div className="rfq-step">
              <span className="step-number">01</span>
              <p className="step-label">Basic Details</p>
            </div>
            <div className="rfq-step">
              <span className="step-number">02</span>
              <p className="step-label">Site Specs</p>
            </div>
            <div className="rfq-step">
              <span className="step-number">03</span>
              <p className="step-label">Fast Quote</p>
            </div>
          </div>
          <div className="rfq-form-box">
            <form
              action="/rfq-portal"
              method="GET"
              data-form-id="a1ee1752-590e-47fd-811f-98c98c6c8266"
              className="rfq-mini-form"
            >
              <input
                type="text"
                id="thq_textinput_hSD_"
                name="textinput"
                required="true"
                placeholder="Project Type (e.g. Commercial Demo)"
                data-form-field-id="thq_textinput_hSD_"
                className="rfq-input"
              />
              <input
                type="email"
                id="thq_textinput_bN9b"
                name="textinput"
                required="true"
                placeholder="Email Address"
                data-form-field-id="thq_textinput_bN9b"
                className="rfq-input"
              />
              <button
                id="thq_button_Jc0z"
                name="button"
                type="submit"
                data-form-field-id="thq_button_Jc0z"
                className="btn btn-secondary"
              >
                Start RFQ Portal
              </button>
            </form>
          </div>
        </div>
      </section>
      <section className="process-section">
        <div className="process-container">
          <h2 className="text-center section-title">How It Works</h2>
          <div className="process-steps">
            <div className="process-item">
              <div className="process-visual">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M11 10v4h4"></path>
                  <path d="m11 14l1.535-1.605a5 5 0 0 1 8 1.5M16 2v4m5 12l-1.535 1.605a5 5 0 0 1-8-1.5"></path>
                  <path d="M21 22v-4h-4m4-9.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3M3 10h4m1-8v4"></path>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="section-subtitle">1. Book Online</h3>
                <p className="section-content">
                  Select your service or dumpster size through our instant
                  booking system.
                </p>
              </div>
            </div>
            <div className="process-item">
              <div className="process-visual">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 17a2 2 0 1 0 4 0a2 2 0 1 0-4 0m10 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0"></path>
                  <path d="M5 17H3v-4M2 5h11v12m-4 0h6m4 0h2v-6h-8m0-5h5l3 5M3 9h4"></path>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="section-subtitle">2. Swift Delivery</h3>
                <p className="section-content">
                  Our fleet arrives on time to deliver your bin or start the
                  demolition work.
                </p>
              </div>
            </div>
            <div className="process-item">
              <div className="process-visual">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 6L9 17l-5-5"></path>
                </svg>
              </div>
              <div className="process-content">
                <h3 className="section-subtitle">3. Clean Finish</h3>
                <p className="section-content">
                  We haul away the debris and ensure the site is spotless and
                  ready for build.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="services-section">
        <div className="services-container">
          <div className="section-header">
            <h2 className="section-title">Our Expertise</h2>
            <p className="section-content">
              Professional solutions for residential and commercial needs.
            </p>
          </div>
          <div className="services-grid">
            <div className="service-item">
              <div className="service-image-wrapper">
                <img
                  alt="Dumpster Rental Service"
                  src="https://images.pexels.com/photos/19547926/pexels-photo-19547926.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="service-img"
                />
                <div className="service-overlay">
                  <h3 className="section-subtitle">Dumpster Rental</h3>
                  <p className="section-content">
                    Roll-off containers for every project size.
                  </p>
                  <a href="/dumpster-rental">
                    <div className="btn-link btn">
                      <span>Learn More</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="service-item">
              <div className="service-image-wrapper">
                <img
                  alt="Full Demolition Service"
                  src="https://images.pexels.com/photos/18940306/pexels-photo-18940306.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="service-img"
                />
                <div className="service-overlay">
                  <h3 className="section-subtitle">Full Demolition</h3>
                  <p className="section-content">
                    Safe and efficient structural removal.
                  </p>
                  <a href="/services">
                    <div className="btn-link btn">
                      <span>Learn More</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="service-item">
              <div className="service-image-wrapper">
                <img
                  alt="Debris Hauling Service"
                  src="https://images.pexels.com/photos/26098429/pexels-photo-26098429.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="service-img"
                />
                <div className="service-overlay">
                  <h3 className="section-subtitle">Debris Hauling</h3>
                  <p className="section-content">
                    Fast removal of construction waste.
                  </p>
                  <a href="/services">
                    <div className="btn-link btn">
                      <span>Learn More</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div className="service-item">
              <div className="service-image-wrapper">
                <img
                  alt="Site Cleanup Service"
                  src="https://images.pexels.com/photos/9373714/pexels-photo-9373714.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="service-img"
                />
                <div className="service-overlay">
                  <h3 className="section-subtitle">Site Cleanup</h3>
                  <p className="section-content">
                    Post-construction grading and clearing.
                  </p>
                  <a href="/services">
                    <div className="btn-link btn">
                      <span>Learn More</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stats-section">
        <div className="stats-grid">
          <div className="stat-item">
            <span className="stat-value">15+</span>
            <span className="stat-label">Years of Service</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">12k</span>
            <span className="stat-label">Dumpsters Delivered</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">450</span>
            <span className="stat-label">Demolition Projects</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">98%</span>
            <span className="stat-label">On-Time Rate</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">24h</span>
            <span className="stat-label">Response Time</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">Zero</span>
            <span className="stat-label">Safety Incidents</span>
          </div>
        </div>
      </section>
      <section className="testimonials-section">
        <div className="section-header">
          <h2 className="section-title">Client Stories</h2>
        </div>
        <div className="carousel-container">
          <div className="carousel-track">
            <div className="testimonial-card">
              <div className="testimonial-rating">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Panda Demolition was incredible. They delivered the
                20-yard bin exactly where I needed it and picked it up the same
                day I called. Highly recommend!&quot;
              </p>
              <div className="testimonial-author">
                <span className="author-name">Marcus Thompson</span>
                <span className="author-title">Homeowner</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-rating">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;We used them for a commercial demo project. Their RFQ
                process was transparent and they stuck to the timeline
                perfectly. Professional crew.&quot;
              </p>
              <div className="testimonial-author">
                <span className="author-name">Sarah Jenkins</span>
                <span className="author-title">Project Manager</span>
              </div>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-rating">
                <span>★★★★★</span>
              </div>
              <p className="section-content">
                &quot;Quickest response in the city. I needed a bin for an
                emergency cleanup and they had one on site within 3 hours. True
                life savers.&quot;
              </p>
              <div className="testimonial-author">
                <span className="author-name">Robert Chen</span>
                <span className="author-title">Contractor</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="location-section">
        <div className="location-container">
          <div className="location-split">
            <div className="location-info">
              <h2 className="section-title">Where We Work</h2>
              <p className="section-content">
                Serving the entire metropolitan area and surrounding suburbs.
                Our fleet is strategically stationed for rapid response.
              </p>
              <ul className="location-list">
                <li className="location-list-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>Downtown &amp; Central Hub</span>
                </li>
                <li className="location-list-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>Northern Industrial Park</span>
                </li>
                <li className="location-list-item">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>Eastern Residential Zone</span>
                </li>
              </ul>
              <div className="contact-cta">
                <p className="section-subtitle">Need immediate help?</p>
                <a href="tel:+19544081674">
                  <div className="btn-lg btn btn-secondary">
                    <span>Call (954) 408-1674</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="location-visual">
              <div className="map-placeholder">
                <img
                  alt="Service Area Map"
                  src="https://images.pexels.com/photos/12175620/pexels-photo-12175620.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                  className="map-img"
                />
                <div className="map-marker">
                  <svg
                    fill="var(--color-secondary)"
                    width="48"
                    xmlns="http://www.w3.org/2000/svg"
                    height="48"
                    stroke="var(--color-surface)"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="home-container4">
        <div className="home-container5">
          <Script
            html={`<script defer data-name="panda-interactions">
(function(){
// Simple Carousel Scroll Handler (Simulated)
const track = document.querySelector('.carousel-track');
if (track) {
  let isDown = false;
  let startX;
  let scrollLeft;

  track.addEventListener('mousedown', (e) => {
    isDown = true;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });

  track.addEventListener('mouseleave', () => {
    isDown = false;
  });

  track.addEventListener('mouseup', () => {
    isDown = false;
  });

  track.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - track.offsetLeft;
    const walk = (x - startX) * 2;
    track.scrollLeft = scrollLeft - walk;
  });
}

// RFQ mini form -> redirect to RFQ portal
const rfqForm = document.querySelector('.rfq-mini-form');
if (rfqForm) {
  rfqForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const btn = rfqForm.querySelector('button');
    btn.textContent = 'Redirecting to Portal...';
    btn.style.opacity = '0.7';
    setTimeout(() => {
      window.location.href = '/rfq-portal';
    }, 500);
  });
}

// Lead form submission via Resend API
const leadForm = document.getElementById('lead-form');
if (leadForm) {
  leadForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = leadForm.querySelector('.quote-modal-submit');
    const status = document.getElementById('lead-form-status');
    btn.textContent = 'Sending...';
    btn.disabled = true;
    status.style.display = 'none';

    const formData = new FormData(leadForm);
    try {
      const resp = await fetch('/api/lead', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.fromEntries(formData)),
      });
      const result = await resp.json();
      if (result.success) {
        status.textContent = '✓ Quote request sent! We\\'ll be in touch shortly.';
        status.style.color = '#16a34a';
        status.style.display = 'block';
        leadForm.reset();
      } else {
        throw new Error(result.error);
      }
    } catch (err) {
      status.textContent = 'Something went wrong. Please call us at (954) 408-1674.';
      status.style.color = '#dc2626';
      status.style.display = 'block';
    }
    btn.textContent = 'Get My Free Quote';
    btn.disabled = false;
  });
}

// Quote popup modal
const quoteModal = document.getElementById('quote-modal');
const openBtn = document.getElementById('open-quote-modal');
const closeBtn = document.getElementById('close-quote-modal');
const stickyBtn = document.getElementById('sticky-open-quote');

if (quoteModal && openBtn && closeBtn) {
  let userInteracted = false;

  openBtn.addEventListener('click', () => { userInteracted = true; quoteModal.showModal(); });
  closeBtn.addEventListener('click', () => quoteModal.close());
  if (stickyBtn) stickyBtn.addEventListener('click', () => { userInteracted = true; quoteModal.showModal(); });
  quoteModal.addEventListener('click', (e) => {
    if (e.target === quoteModal) quoteModal.close();
  });

  // Auto-open popup after 5 seconds if user hasn't clicked anything
  document.addEventListener('click', () => { userInteracted = true; }, { once: true });
  setTimeout(() => {
    if (!userInteracted && !quoteModal.open) {
      quoteModal.showModal();
    }
  }, 5000);
}
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
      <div className="sticky-cta-bar">
        <a href="tel:+19544081674" className="sticky-cta-call">
          <svg fill="none" width="20" height="20" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <span>Call Now</span>
        </a>
        <button className="sticky-cta-quote" onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')}>
          <span>Book Now</span>
        </button>
      </div>
    </div>
  )
}

export default Home
